<template>
    <ResponsiveDialog :value="value" @input="$emit('input', $event)" max-width="400" :header-title="$t('user.userChanger.title')" header-class="skin-window-header--userchanger" :z-index="3500" card-class="skin-card">
        <div class="skin-window--userchanger userchanger-adaptive-text userchanger-bg">
            <v-card-text>
                <v-select
                    :items="users"
                    v-model="selectedId"
                    item-value="id"
                    item-text="name"
                    :label="$t('user.userChanger.userLabel')"
                    :loading="isLoading"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="isImpersonating"
                    text
                    color="warning"
                    @click="onReturnToAdmin"
                >
                    {{ $t('user.userChanger.backToAdmin') }}
                </v-btn>
                <v-spacer/>
                <v-btn
                    color="primary"
                    :disabled="!selectedId"
                    @click="onConfirm"
                >
                    {{ $t('user.userChanger.confirm') }}
                </v-btn>
            </v-card-actions>
        </div>
    </ResponsiveDialog>
</template>

<script>
    // z-index 3500 (default 1200) - otevira se POKUD NavDrawer.vue menu zustava otevrene (na z-index 3000), jinak by dialog byl schovany pod nim
    import {mapActions, mapGetters} from 'vuex';
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';

    export default {
        name: 'UserChanger',
        components: {ResponsiveDialog},
        props: {
            value: {type: Boolean, default: false},
        },
        data() {
            return {
                selectedId: null,
            }
        },
        computed: {
            ...mapGetters({
                isLoading: 'user/isLoading',
                users: 'user/items',
                isImpersonating: 'user/isImpersonating',
            }),
        },
        watch: {
            value(isOpen) {
                if (isOpen) {
                    this.selectedId = null;
                    this.getUsers();
                }
            },
        },
        methods: {
            ...mapActions({
                getUsers: 'user/loadItems',
                impersonate: 'user/impersonate',
                returnToAdmin: 'user/returnToAdmin',
            }),
            onConfirm() {
                this.impersonate(this.selectedId);
                this.$emit('input', false);
            },
            onReturnToAdmin() {
                this.returnToAdmin();
                this.$emit('input', false);
            },
        },
    }
</script>

<style scoped>
/* pozadi ridi skin (.skin-window--userchanger, public/skins/normal.css) */
.userchanger-bg {
    display: flex;
    flex-direction: column;
    min-height: 0;
}
.theme--light .userchanger-adaptive-text {
    color: rgba(0, 0, 0, .87);
}
.theme--dark .userchanger-adaptive-text {
    color: rgba(255, 255, 255, .87);
}
</style>
